import React from 'react';
import SelectField from '../../../../Dropdown/select/SelectField';
const DropdownInput = ({ id , label , isLabelHidden , items , wrapperClassName , value , onSelect  })=>/*#__PURE__*/ React.createElement(SelectField, {
        id: id,
        label: label,
        isLabelHidden: isLabelHidden,
        className: wrapperClassName,
        onSelect: onSelect,
        items: items,
        value: value,
        withBlankOption: false
    });
DropdownInput.displayName = 'DropdownInput';
export default DropdownInput;
